import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=a7a5cc96"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7a5cc96')) {
      api.createRecord('a7a5cc96', component.options)
    } else {
      api.reload('a7a5cc96', component.options)
    }
    module.hot.accept("./AdditionalInfo.vue?vue&type=template&id=a7a5cc96", function () {
      api.rerender('a7a5cc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/periodEnd/components/AdditionalInfo.vue"
export default component.exports